
import Navbar from './components/Navbar';
import Container from './components/Container';
import { Routes, Route } from "react-router-dom";
import './App.css';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import SingleProject from './pages/SingleProject';
import Login from './pages/Login';
import Register from './pages/Register';
//import ProtectedRoute from './components/ProtectedRoute';


function App() {
  return (
    <div className="App">
      <Navbar />
      
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/singleproject/:id" element={<SingleProject />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/login' element={<Login/>}/>
          <Route path='/register' element={<Register/>}/>
          {/*<Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />*/}
        </Routes>
      </Container>

      <Footer />
    </div>
  );
}

export default App;
